import axiosInstance from './axiosInstance';

/* ── Talent 일정 ── */

/** GET /api/talent/schedules?startDate=YYYY-MM-DD&endDate=YYYY-MM-DD */
export const getSchedules = async (startDate, endDate) => {
  const res = await axiosInstance.get('/api/talent/schedules', { params: { startDate, endDate } });
  return Array.isArray(res.data) ? res.data : (res.data?.content ?? []);
};

/** POST /api/talent/schedules */
export const createSchedule = async (body) => {
  const res = await axiosInstance.post('/api/talent/schedules', body);
  return res.data;
};

/** PATCH /api/talent/schedules/{id} */
export const updateSchedule = async (id, body) => {
  const res = await axiosInstance.patch(`/api/talent/schedules/${id}`, body);
  return res.data;
};

/** DELETE /api/talent/schedules/{id} */
export const deleteSchedule = async (id) => {
  await axiosInstance.delete(`/api/talent/schedules/${id}`);
};

/* ── Producer 일정 ── */
// getProducerSchedules 는 producerDashboardApi.js 에 이미 정의되어 있음

/** POST /api/producer/schedules */
export const createProducerSchedule = async (body) => {
  const res = await axiosInstance.post('/api/producer/schedules', body);
  return res.data;
};

/** PATCH /api/producer/schedules/{id} */
export const updateProducerSchedule = async (id, body) => {
  const res = await axiosInstance.patch(`/api/producer/schedules/${id}`, body);
  return res.data;
};

/** DELETE /api/producer/schedules/{id} */
export const deleteProducerSchedule = async (id) => {
  await axiosInstance.delete(`/api/producer/schedules/${id}`);
};
